import { isExternal } from '@src/common/is_external_href';
import '@src/common/utilities';

window.pageIdForToolsSynch = getHash();

const ANALYTICS_TEMPLATE_STRICT_MATCHING = {
  '/fr': 'HP',
  '/de': 'HP',
  '/it': 'HP',
  '/en': 'HP',
  '/es': 'HP'
};

const ANALYTICS_TEMPLATE_LOOSE_MATCHING = {
  '/blog': 'Blog',
  '/tips': 'Tips',
  '/pricing': 'Business',
  '/team': 'Business',
  '/payment-methods': 'Business',
  '/open-an-account': 'Business',
  '/accounting': 'Business',
  '/multi-account': 'Business',
  '/connect': 'Business',
  '/capital-deposit': 'Business',
  '/company-creation': 'Business',
  '/small-business': 'Business',
  '/medium-business': 'Business',
  '/freelancers': 'Business',
  '/sme': 'Business',
  '/compare-pricing': 'Business',
  '/contact-form': 'Business'
};

function currentPageTemplate() {
  const path = location.pathname.substring();
  if (ANALYTICS_TEMPLATE_STRICT_MATCHING[path]) {
    return ANALYTICS_TEMPLATE_STRICT_MATCHING[path]
  }

  for (const key of Object.keys(ANALYTICS_TEMPLATE_LOOSE_MATCHING)) {
    const match = path.match(new RegExp(key));
    if (match) {
      return ANALYTICS_TEMPLATE_LOOSE_MATCHING[match]
    }
  }

  return 'Other';
}

// This should be refactor
// A regexp of something can match multiple countries at once
const ANALYTICS_UNIVERSE_MATCHING_SILOS = [
  '/fr/open-an-account',
  '/fr/capital-deposit',
  '/fr/creation',
  '/fr/payment-methods',
  '/fr/comparators',
  '/fr/team',
  '/fr/blog',
  '/fr/tips',
  '/es/open-an-account',
  '/es/capital-deposit',
  '/es/company-creation',
  '/es/creation',
  '/es/payment-methods',
  '/es/comparators',
  '/es/team',
  '/es/blog',
  '/es/tips',
  '/de/open-an-account',
  '/de/company-creation',
  '/de/capital-deposit',
  '/de/creation',
  '/de/payment-methods',
  '/de/comparators',
  '/de/team',
  '/de/blog',
  '/de/tips',
  '/it/open-an-account',
  '/it/company-creation',
  '/it/payment-methods',
  '/it/comparators',
  '/it/team',
  '/it/blog',
  '/it/tips',
  '/en/open-an-account',
  '/en/capital-deposit',
  '/en/creation',
  '/en/payment-methods',
  '/en/comparators',
  '/en/team',
  '/en/comparators',
  '/en/team',
  '/en/blog',
  '/en/tips'
];

function currentPageUniverse() {
  const path = location.pathname.substring();
  for (const silo of ANALYTICS_UNIVERSE_MATCHING_SILOS) {
    const match = path.match(new RegExp(silo))
    if (match) {
      return silo;
    }
  }

  return 'Other';
}

//these structured events will be sent to segment on the following click actions for improving tracking and model attribution
const ANALYTICS_PLUGINS = {
  // when sign_in is clicked
  website_signin_clicked: function (params) {
    return {
      page_url: params.currentUrl,
      command: 'cta_signin',
      category: 'Navigation',
      action: 'CTA Signin',
      label: params.location,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    }
  },
  // when sign up is clicked
  website_cta_signup_clicked: function (params) {
    return {
      page_url: params.currentUrl,
      command: 'cta_signup',
      category: 'Navigation',
      action: 'CTA Signup',
      label: params.label || undefined,
      location: params.location,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    }
  },
  // when a partner link is clicked
  website_cta_partner_clicked: function (params) {
    return {
      page_url: params.currentUrl,
      command: 'partner_link',
      category: 'Navigation',
      action: 'Partner Link',
      label: new URL(params.target).origin,
      location: params.location,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    }
  },
  // when a book a demo link is clicked
  website_cta_go_to_demo_form: function (params) {
    return {
      page_url: params.currentUrl,
      command: 'cta_demo',
      category: 'Navigation',
      action: 'CTA',
      location: params.location,
      label: params.label,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    }
  },
  // rest of cta's use case clicks
  cta: function (params) {
    return {
      page_url: params.currentUrl,
      command: 'cta',
      category: 'Navigation',
      action: 'CTA',
      label: params.text,
      location: params.location,
      target: params.target,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    }
  },
  website_cta_bylaws_template_download: function (params) {
    const status = params.currentUrl.match(/statuts-(.*)/)[1];
    return {
      command: 'cta',
      category: 'Navigation',
      action: 'CTA',
      label: 'Download Bylaws Template',
      location: status,
      target: params.currentUrl,
      user_ga_id: getGaId(),
      id_tools_synch: getHash(),
      gdpr_consent_status: getDidomiCookieConsent(),
      url: params.currentUrl,
    };
  }
};

var genericTrackingHandler = function () {
  var canTrack = (window && window.analytics);
  if (!canTrack) { return }

  var eventName = $(this).data('track');
  // Whitelist is defined in url_tracking_events.rb via analytics_events.js.erb
  var trackersWhiteList = $('#trackersWhiteList').data('trackers-white-list')
  if (trackersWhiteList.indexOf(eventName) == -1) {
    if (isExternal($(this).attr('href'))) {
      eventName = 'website_cta_partner_clicked';
      if ($(this).parents('section')[0]) {
        $(this).data('location', $(this).parents('section')[0].id);
      }
      $(this).data('label', new URL($(this).attr('href')).origin);
    } else {
      // console.log("Unknown tracking: '" + eventName + "''"); // Handy for debugging
      return;
    }
  }
  var location = $(this).data('location');
  var label = $(this).data('label');
  var target = $(this).attr('href');
  var currentUrl = window.location.href;
  var text = $(this).text();
  // in case ga is blocked by an adblocker
  try {
    var gaClientId = ga.getAll()[0].get('clientId');
    // Sends GA id to Segment personas
    var options = {
      context: {
        integrations: {
          'Google Analytics': {
            clientId: gaClientId
          }
        }
      }
    }
  } catch (error) {
    var options = {};
  }

  var data = {
    location: location,
    page_url: currentUrl,
    label: location,
    user_ga_id: getGaId(),
    id_tools_synch: getHash(),
    gdpr_consent_status: getDidomiCookieConsent(),
    url: currentUrl,
  };
  var plugin = ANALYTICS_PLUGINS[eventName];
  if (!plugin && eventName.includes('cta')) {
    plugin = ANALYTICS_PLUGINS['cta'];
  }

  if (plugin) {
    data = plugin({
      currentUrl: currentUrl,
      location: location,
      target: target,
      label: label,
      text: text,
      url: currentUrl,
    })
  }

  // Remove whitespace (\n) and é accent.
  if (eventName === 'blog_cta_discover_clicked' && data.label) {
    data.label = data.label.replace('é', 'e').trim();
  }

  window.analytics.track(
    eventName,
    data,
    options
  );
}



$(window).on('load', function () {
  $('a').on('click', genericTrackingHandler);
  $('button').on('click', genericTrackingHandler);
  var canTrack = (window && window.analytics);
  if (canTrack) {
    const currentLocale = window.location.href.split('/')[3];
    window.analytics.identify(
      {
        user_ga_id: getGaId(),
        gdpr_consent_status: getDidomiCookieConsent(),
        website_locale: currentLocale,
        url: location.href,
      }
    );
  }
});





function segmentLoadAndPage() {
  // Segment load method
  var segmentKey = document.querySelector('#segmentKey').dataset.segmentKey;
  analytics.load(
    segmentKey,
    {
      integrations: {
        // Syntax: '%Segment_Destination_Name%': Didomi.getUserConsentStatusForVendor('%Didomi_Vendor_SDK_Id%'),
        'Google Analytics': true, // because purpose: "Internal Analytics" (required)
        'Amplitude': Didomi.getUserConsentStatusForVendor('c:amplitude'),
        'Facebook Pixel': Didomi.getUserConsentStatusForVendor('c:fb-ads'),
        'Facebook Conversions API': Didomi.getUserConsentStatusForVendor('c:fb-ads'),
        'Google Ads (Classic)': Didomi.getUserConsentStatusForVendor('c:double-click'),
        'Google Tag Manager': true, // because purpose: "Technical cookies" (required)
        'LinkedIn Insight Tag': Didomi.getUserConsentStatusForVendor('c:linkedin'),
        'ActiveCampaign': true, // can't opt-out because qto_internal_analytics (required)
        'Bing Ads': Didomi.getUserConsentStatusForVendor('c:bing-ads'),
        'Hotjar': true, // because purpose: "Internal Analytics" (required)
        'Intercom': Didomi.getUserConsentStatusForVendor('c:intercom'),
        'Twitter Ads': Didomi.getUserConsentStatusForVendor('c:twitter'),
        'DoubleClick Floodlight': Didomi.getUserConsentStatusForVendor('c:double-click'),
        'AdWords Remarketing Lists': Didomi.getUserConsentStatusForVendor('c:double-click'),
        'Google Ads (Gtag)': Didomi.getUserConsentStatusForVendor('c:double-click'),
        'AdWords': Didomi.getUserConsentStatusForVendor('c:g-adwords')
      }
    }
  );

  // Segment page method
  analytics.page({
    user_ga_id: getGaId(),
    url: location.href,
    id_tools_synch: window.pageIdForToolsSynch,
    gdpr_consent_status: getDidomiCookieConsent(),
    page_template: currentPageTemplate(),
    page_universe: currentPageUniverse(),
    page_country: location.pathname.split('/').filter(n => n)[0],
    user_platform: /Mobi/i.test(window.navigator.userAgent) ? 'Web Mobile' : 'Web Desktop'
  });
};

// Send info to data layer
window.dataLayer = window.dataLayer || [];
dataLayer.push({
  event: 'static_datalayer',
  id_tools_synch: window.pageIdForToolsSynch,
  gdpr_consent_status: getDidomiCookieConsent(),
  page_template: currentPageTemplate(),
  page_universe: currentPageUniverse(),
  page_country: location.pathname.split('/').filter(n => n)[0],
  user_platform: /Mobi/i.test(window.navigator.userAgent) ? 'Web Mobile' : 'Web Desktop'
});
window.didomiOnReady = window.didomiOnReady || [];
window.didomiOnReady.push(function (Didomi) {
  // Didomi ready : the Didomi JS library is loaded
  if (!Didomi.shouldConsentBeCollected()) {
    // Consent has already been collected : Segment load and page
    segmentLoadAndPage();
  } else {
    // Consent has not been collected yet
    Didomi.on('consent.changed', function () {
      // Consent has been collected (changed for the first): Segment load and page
      segmentLoadAndPage();
    });
  }
});

function afterDidomiDisappeared(callback) {
  window.didomiOnReady.push(function (Didomi) {
    if (Didomi.shouldConsentBeCollected()) {
      Didomi.on('notice.hidden', callback);
    } else {
      callback();
    }
  });
};

export {
  afterDidomiDisappeared
}
